export default __webpack_public_path__ + "static/media/Topnotchquality.e59be010.png";